import Proxy from '../Proxy';

class EstimationComplexProxy extends Proxy {
  /**
   * The constructor for the EstimationComplexProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('estimations-complex', parameters);
  }

  deleteAttachment(uuid, attachmentId) {
    return this.submit('delete', `${this.endpoint}/${uuid}/attachments/${attachmentId}`);
  }
}

export default EstimationComplexProxy;
